import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_031",
  "use": "icon-su_031-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-su_031\"><defs><style>#icon-su_031 .cls-1{fill:#fff;}#icon-su_031 .cls-2{fill:#d4d4d4;}</style></defs><g id=\"icon-su_031_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_031_icon\"><rect class=\"cls-1\" x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" /><path class=\"cls-2\" d=\"M15,1V15H1V1H15m1-1H0V16H16V0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol